import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16.928 11.802"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      stroke: "#001e41",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      "data-name": "Group 257"
    }, [
      _createElementVNode("path", {
        d: "M.75 5.004h3.457v6.048H.75z",
        "data-name": "Rectangle 143"
      }),
      _createElementVNode("path", {
        d: "M12.721 7.291h3.457v3.761h-3.457z",
        "data-name": "Rectangle 144"
      }),
      _createElementVNode("path", {
        d: "M6.735.75h3.457v10.302H6.735z",
        "data-name": "Rectangle 145"
      })
    ], -1)
  ])))
}
export default { render: render }